module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "label": _vm.data.label
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-select', {
    class: _vm.verifyFields(_vm.data, _vm.validation) && !_vm.disabled ? 'input-warning' : '',
    staticStyle: {
      "margin-left": "11%"
    },
    attrs: {
      "disabled": _vm.disabled,
      "placeholder": _vm.data.placeholder,
      "required": _vm.data.required
    },
    on: {
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.data.model, _vm.data.name)
      }
    },
    model: {
      value: (_vm.data.model),
      callback: function($$v) {
        _vm.$set(_vm.data, "model", $$v)
      },
      expression: "data.model"
    }
  }, _vm._l((_vm.data.optionValue), function(option, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": option.label,
        "value": option.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 23
    }
  }, [(_vm.verifyFields(_vm.data, _vm.validation) && !_vm.disabled) ? _c('el-alert', {
    staticClass: "message-warning",
    attrs: {
      "title": ("Falta completar: " + (_vm.data.label)),
      "type": "error",
      "closable": false
    }
  }) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ba1ef84"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/SelectInput.vue
// module id = 629
// module chunks = 1